// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from './base-entity';
import { Customer } from './customer';
import { Equipment } from './equipment';
import { EquipmentAttachment } from './equipment-attachment';
import { EquipmentStatus } from './equipment-status';
import { Expense } from './expense';
import { PurchaseTransaction } from './purchase-transaction';
import { SalesTransaction } from './sales-transaction';
import { Supplier } from './supplier';
import { TransactionType } from './transaction-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class ApplicationUser extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id: string;
  accessFailedCount: number;
  color: string;
  concurrencyStamp: string;
  email: string;
  emailConfirmed: boolean;
  firstName: string;
  fullName: string;
  lastName: string;
  lockoutEnabled: boolean;
  lockoutEnd: Date;
  normalizedEmail: string;
  normalizedUserName: string;
  passwordHash: string;
  phoneNumber: string;
  phoneNumberConfirmed: boolean;
  securityStamp: string;
  twoFactorEnabled: boolean;
  userName: string;
  customers: Customer[];
  equipmentAttachments: EquipmentAttachment[];
  equipmentStatuses: EquipmentStatus[];
  equipments: Equipment[];
  expenses: Expense[];
  purchaseTransactions: PurchaseTransaction[];
  salesTransactions: SalesTransaction[];
  suppliers: Supplier[];
  transactionTypes: TransactionType[];
}

